import { useEffect } from 'react';
import { useSettings } from 'src/context/SettingsContext';
import { ui } from '@annote/core/styles';

/**
 * Component that applies dynamic CSS custom properties based on user settings
 */
export const DynamicStyles: React.FC = () => {
  const { settings } = useSettings();

  useEffect(() => {
    // Apply CSS custom properties to the document root
    const root = document.documentElement;

    if (settings.highlights.defaultColor) {
      root.style.setProperty('--highlight-default-color', settings.highlights.defaultColor);
    }

    if (settings.highlights.noteHighlightColor) {
      root.style.setProperty('--highlight-note-color', settings.highlights.noteHighlightColor);
    }
  }, [settings.highlights.defaultColor, settings.highlights.noteHighlightColor]);

  useEffect(() => {
    // Update icon size in ui module
    ui.setIconSize(settings.ui.iconSize);
  }, [settings.ui.iconSize]);

  return null;
};
